import React from 'react';
import connect from 'react-redux/lib/connect/connect';
import { Route, Link } from 'react-router-dom';
import NavLink from 'react-router-dom/NavLink';
import { logoutUser } from '../../common/actions/userActions';
import { isEmpty, isMobilePage } from '../../common/cores';

const MenuInfos = [
    {
        url: "/dashboard",
        title: "입금신청",
        className: "fa-yellow fa-light fa-money-bill-transfer fa-2x",
        contentText: "입금신청과 내역을 확인할 수 있습니다"
    },
    {
        url: "/account/withdrawal",
        title: "출금신청",
        className: "fa-yellow fa-solid fa-money-bill-transfer fa-2x",
        contentText: "출금신청과 내역을 확인할 수 있습니다"
    },
    // {
    //     url: "/account/exchange",
    //     title: "카지노머니전환",
        // className: "fa-yellow fa-solid fa-arrows-rotate fa-2x",
    //     contentText:"게임머니전환과 내역을 확인할수 있습니다" 
    // },
    {
        url: "/account/point",
        title: "포인트전환",
        className: "fa-yellow fa-solid fa-arrows-repeat fa-2x",
        contentText: "포인트전환과 내역을 확인할수 있습니다."
    },
    {
        url: "/account/histories",
        title: "베팅내역",
        className: "fa-yellow fa-light fa-folder-bookmark fa-2x",
        contentText: "베팅내역을 확인할수 있습니다."
    },
    {
        url: "/account/attendance",
        title: "출석체크",
        className: "fa-yellow fa-regular fa-clipboard-user fa-2x",
        contentText: "출석체크이벤트에 참가할수 있습니다."
    },
    {
        url: "/account/notices",
        title: "공지사항 및 규정",
        className: "fa-yellow fa-regular fa-circle-exclamation fa-2x",
        contentText: "공지사항을 확인할수 있습니다."
        
    },
    {
        url: "/account/messages",
        title: "메세지",
        className: "fa-yellow fa-light fa-envelope fa-2x",
        contentText: "메세지 수신내역을 확인할수 있습니다."
    },
    {
        url: "/account/inquiries",
        title: "1:1 문의",
        className: "fa-yellow fa-regular fa-messages-question fa-2x",
        contentText: "1:1 문의 신청내역을 확인할수 있습니다."
    },
    {
        url: "/account/recommender",
        title: "추천인",
        className: "fa-yellow fa-solid fa-users-medical fa-2x",
        contentText: "추천인 내역을 확인할수 있습니다."
    },
    {
        url: "/account/setting",
        title: "개인정보수정",
        className: "fa-yellow fa-solid fa-user-gear fa-2x",
        contentText: "개인정보를 수정할수 있습니다."
    }
]

const MenuItem = ({ info, setShowMenu}) => {
    return (
        <div data-v-394b74b4="" className="column">
                <NavLink activeClassName="router-link-active" data-v-394b74b4="" to = { info.url } aria-current="page" className="button" onClick={setShowMenu}>
                    <div data-v-394b74b4="" className="row" style={{ flexDirection: "row" }}>
                        <span data-v-394b74b4="" className="text">
                            <i data-v-e56d064c="" data-v-394b74b4="" className={info.className}></i>
                        </span>
                    </div>
                    <div data-v-394b74b4="" className="text-ellipsis column">
                        <span data-v-394b74b4="" className="head-text text"> { info.title } </span>
                        <span data-v-394b74b4="" className="text" style={{ opacity: 0.6 }}> {info.contentText} </span>
                    </div>
                </NavLink>
            </div>
    )
} 
const isMobile = isMobilePage();

const SideMenuBar = (props) => {

    const onlogout = () => {
        props.setShowMenu();
        props.logoutUser();
    }

    const { unreadNotes } = props;
    // console.log(props)
    return (
        <div data-v-394b74b4="" className={`scrollable-auto menu column right-out ${isMobile ? "MobileRight" :""} ${props.showMenu ? "show" : ""}`} style={{marginBottom: "50px", height: "100%", padding: "45px 15px" }}>
            { isMobilePage() && <div data-v-2fe6782b="" className="user column" style={{flexShrink: "0"}}>
                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                    <div data-v-2fe6782b="" className="level row" style={{flexDirection: "row"}}>
                        <span data-v-2fe6782b="" className="margin-right-5 text" style={{color: "rgb(246, 195, 58)"}}>Lv.1</span> 
                        {/* <span data-v-2fe6782b="" className="text">Bronze</span> */}
                    </div>
                    <div data-v-2fe6782b="" className="spacer"></div> 
                    <button data-v-2fe6782b="" className="button text" style={{background: "transparent"}} onClick={onlogout}>
                        <span data-v-2fe6782b="" className="text" style={{color: "rgb(255, 117, 117)", fontWeight: "bold"}}>로그아웃</span>
                    </button>
                    {/* <button data-v-2fe6782b="" className="button text" style={{background: "transparent"}} onClick={props.setShowMenu}>
                        <span data-v-2fe6782b="" className="text" style={{color: "rgb(255, 117, 117)", fontWeight: "bold"}}>
                            <img src="../images/header/hidden.png" alt="" style={{height:"20px", marginLeft: "10px"}}/>
                        </span>
                    </button> */}
                </div>
                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                    <span data-v-2fe6782b="" className="text" style={{alignItems: "baseline"}}>
                        <span data-v-2fe6782b="" className="nickname margin-right-5 text-level-6 text" style={{color: "rgb(246, 195, 58)"}}>{props.user.name}</span> 
                        <span data-v-2fe6782b="" className="text">{isEmpty(window.lang["환영합니다"]) ? "환영합니다" : window.lang["환영합니다"]}</span>
                    </span>
                </div>
                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                    <Link data-v-2fe6782b="" to="/account/messages" className="button text" style={{background: "transparent"}}>
                        <span data-v-2fe6782b="" className="text">
                            읽지 않은 메세지가 
                            <span data-v-2fe6782b="" className="margin-horizontal-5 text" style={{color: "rgb(246, 195, 58)", fontWeight: "bold"}}>
                                {unreadNotes.length}
                            </span>건 있습니다.
                        </span>
                    </Link>
                    <div data-v-2fe6782b="" className="spacer"></div>
                </div>
                <div data-v-2fe6782b="" className="wallet column">
                    <div data-v-2fe6782b="" className="wallet-info row" style={{flexDirection: "row"}}>
                        <div data-v-2fe6782b="" className="column">
                            <a data-v-2fe6782b=""  className="deposit button text" style={{background: "transparent"}}>
                                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                                    <span data-v-2fe6782b="" className="text">보유금액</span>
                                </div>
                                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                                    <span data-v-2fe6782b="" className="text" style={{color: "rgb(246, 195, 58)"}}>{ !isEmpty(props.user.balance) ? Number(props.user.balance.money).toLocaleString() : "0"}</span>
                                </div>
                            </a>
                        </div>
                        <div data-v-2fe6782b="" className="column">
                            <a data-v-2fe6782b="" className="trasnfer button text" style={{background: "transparent"}}>
                                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                                    <span data-v-2fe6782b="" className="text">보유포인트</span>
                                </div>
                                <div data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                                    <span data-v-2fe6782b="" className="text" style={{color: "rgb(246, 195, 58)"}}>{!isEmpty(props.user.balance) ? Number(props.user.balance.rolling).toLocaleString() : "0"}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>}
            {
                MenuInfos.map((itemInfo, index) =>(
                    <MenuItem info={itemInfo} key={index} setShowMenu={props.setShowMenu}/>
                ))
            }
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.user.data,
    unreadNotes: state.more.message.unreadNotes
  });

export default connect(mapStateToProps, { logoutUser })(SideMenuBar);


// WEBPACK FOOTER //
// ./src/components/account/SideMenuBar.js